import { render } from "./NewDetail.vue?vue&type=template&id=0fe4dc60&scoped=true"
import script from "./NewDetail.vue?vue&type=script&lang=js"
export * from "./NewDetail.vue?vue&type=script&lang=js"

import "./NewDetail.vue?vue&type=style&index=0&id=0fe4dc60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe4dc60"]])

export default __exports__